import { isQuestionTitle, questionTitle } from '@edulastic/constants'
import {
  MULTIPLE_CHOICE,
  MULTIPLE_SELECTION,
  TRUE_OR_FALSE,
  CLOZE_TEXT,
  SHORT_TEXT,
} from '@edulastic/constants/const/questionType'
import { parseHTMLToPlainText } from './htmlParser'

export const titleToAIQuestionType = (title) => {
  if (isQuestionTitle(title, questionTitle.MCQ_STANDARD)) {
    return MULTIPLE_CHOICE
  }
  if (isQuestionTitle(title, questionTitle.MCQ_TRUE_OR_FALSE)) {
    return TRUE_OR_FALSE
  }
  if (isQuestionTitle(title, questionTitle.MCQ_MULTIPLE_RESPONSE)) {
    return MULTIPLE_SELECTION
  }
  if (title === questionTitle.CLOZE_TEXT) {
    return CLOZE_TEXT
  }
  if (title === questionTitle.SHORT_TEXT) {
    return SHORT_TEXT
  }
  return null
}

export const passagesToAIPrompt = (passages) => {
  return passages
    ?.map((passage, index) => {
      const { title, heading, source, pages, content } = passage

      let formattedPassage = `Passage ${index + 1}:\n`
      formattedPassage += `Title:  ${title}\n`
      formattedPassage += `Heading:  ${parseHTMLToPlainText(heading)}\n`
      if (source) {
        formattedPassage += `Source:  ${parseHTMLToPlainText(source)}\n`
      }
      if (pages) {
        formattedPassage += `Content: \n`
        pages.forEach((page) => {
          formattedPassage += `${parseHTMLToPlainText(page)}\n`
        })
      } else if (content) {
        formattedPassage += `Content: ${parseHTMLToPlainText(content)}\n`
      }

      return formattedPassage
    })
    .join('\n')
}

export const getPassagePreference = (passages, preference) => {
  let formattedPassage = ''
  if (passages?.length || preference) {
    if (passages?.length) {
      formattedPassage +=
        'Generate question based upon on below passage content:\n'
      formattedPassage += passagesToAIPrompt(passages)
    }
    if (preference) {
      formattedPassage += 'Also consider below content type:\n'
      formattedPassage += preference
    }
  }
  return formattedPassage
}
